/**
 * @generated SignedSource<<41355ecd1d4260bd292793c407a12b96>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
export type identityprovidertype = "AXON" | "OIDC" | "SAML" | "UNKNOWN" | "%future added value";
import { FragmentRefs } from "relay-runtime";
export type TeamView_identityProviderFragment$data = {
  readonly identityProviderConfigurations: {
    readonly edges: ReadonlyArray<{
      readonly node: {
        readonly id: string;
        readonly name: string;
        readonly providerType: identityprovidertype;
        readonly uuid: string;
      } | null;
    } | null>;
  } | null;
  readonly " $fragmentType": "TeamView_identityProviderFragment";
};
export type TeamView_identityProviderFragment$key = {
  readonly " $data"?: TeamView_identityProviderFragment$data;
  readonly " $fragmentSpreads": FragmentRefs<"TeamView_identityProviderFragment">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "TeamView_identityProviderFragment",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "IdentityProviderConfigurationConnection",
      "kind": "LinkedField",
      "name": "identityProviderConfigurations",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "IdentityProviderConfigurationEdge",
          "kind": "LinkedField",
          "name": "edges",
          "plural": true,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "IdentityProviderConfiguration",
              "kind": "LinkedField",
              "name": "node",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "id",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "uuid",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "name",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "providerType",
                  "storageKey": null
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Organization",
  "abstractKey": null
};

(node as any).hash = "77a3c04f8b30c1a071da4aa9164f3271";

export default node;
